require('bootstrap/dist/js/bootstrap.bundle')
require('./main')
require('./fadeScroll')